import {AssetHistoryApiDto} from "../../api/model/rest";
import {TierLevel} from "./Asset";
import * as moment from "moment";
import {option, Option} from "ts-option";

export default class AssetHistory {
	constructor(public readonly revisionNo: number,
		public readonly dateTime: moment.Moment,
		public readonly assetId: string,
		public readonly categoryId: string,
		public readonly manufacturer: Option<string>,
		public readonly model: string,
		public readonly price: number,
		public readonly secondaryPrice: Option<number>,
		public readonly rebate: Option<number>,
		public readonly type: Option<string>,
		public readonly disabled: boolean,
		public readonly firstMerchantCode: Option<string>,
		public readonly secondMerchantCode: Option<string>,
		public readonly description: Option<string>,
		public readonly markup: number,
		public readonly tierLevel: TierLevel,
		public readonly rewardsPoints: number,
		public readonly keywords: string[],
		public readonly alertNote: Option<string>,
		public readonly warrantyCode: Option<string>) {}

	static fromJson(json: AssetHistoryApiDto): AssetHistory {
		return new AssetHistory(json.revisionNo, moment(json.dateTime), json.assetId, json.categoryId, option(json.manufacturer),
			json.model, json.price, option(json.secondaryPrice), option(json.rebate), option(json.type), json.disabled,
			option(json.firstMerchantCode),
			option(json.secondMerchantCode), option(json.description), json.markup, TierLevel[json.tier], json.points,
			json.keywords, option(json.alertNote),
			option(json.warrantyCode)
		);
	}

	formatPrice(): string {
		return (this.price / 100).toLocaleString("en-IE", {style: "currency", currency: "EUR"});
	}

	formatSecondaryPrice(): string {
		return this.secondaryPrice.map(sp => (sp / 100).toLocaleString("en-GB", {style: "currency", currency: "GBP"})).orNull;
	}
}
